export default "__VITE_ASSET__BdhRGu1r__"